module.exports = __webpack_public_path__ + "img/jungle-town-unknown.339d2281.jpg";